export default "__VITE_ASSET__9163cff1__"